import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Grid, Box, Button} from '@material-ui/core';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import MuiDialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import TextField from '@mui/material/TextField';
import axios from 'axios';
import 'font-awesome/css/font-awesome.min.css';
import { useSelector } from 'react-redux';
import {API_URL} from '../utils/EnvVars';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
});


var vertical='top',horizontal='center';

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const CustomizedDialogs = React.forwardRef((props, ref) => {  
  const userObj = useSelector(state => state.userDetails);
  const [open, setOpen] = React.useState(false); 
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [roleName, setRoleName] = React.useState("");
  const [description, setDescription] = React.useState("");
  const [privileges, setPrivileges] = React.useState("");

  
  React.useImperativeHandle(ref, () => ({
    handleClickOpen(){
      setOpen(true);
    }
  }));
  
  const handleClose = () => {
    setOpen(false);
  };

  function hideAlert(){
		setShowAlert(false);
	}

	function saveData(){
    if(!roleName){
      setSeverityAlert("error");
      setShowAlert(true);
      setAlertMessage("Enter role name");			
      return false;
    }

		if(roleName){ 
			let axiosHeader = {
				headers: {
					'Content-Type': 'multipart/mixed',
          'token': userObj.token,
          'loginEmailId': userObj.emailId,
				}
			}; 
    
      const data = new FormData();
      data.append('roleName', roleName);
      data.append('description', description);
      data.append('privileges', privileges);
             
			axios.post(API_URL+'/admin-new-role', data, axiosHeader)
			.then((response) => {
				console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
				if(response.data.responseTxt==="success"){
          setSeverityAlert("success");
          setOpen(false);
					setShowAlert(true);
					setAlertMessage("Role details has been saved.");
          window.location.reload();	
					return false;
        }else if(response.data.responseTxt==="AlreadyExistsError"){
            setSeverityAlert("error");
            setOpen(true);
            setShowAlert(true);
            setAlertMessage("Role name must be unique. It is added earlier.");
            return false;  					
				}else{
          setSeverityAlert("error");
					setShowAlert(true);
					setAlertMessage("Role details could not be saved.");			
					return false;
				}
			})
			.catch((error) => {
				console.log("AXIOS ERROR: ", error);
			})	
		}		
	}
  
  function checkAllList(chkboxid,chkid)	{
    if(props.modules){
      if(document.getElementById(chkboxid).checked==true){
        for (let i=0; i<props.modules.length; i++)
        {
          eval('document.getElementById("'+chkid+i+'").checked=true');
        }
      }else{
        for (let i=0; i<props.modules.length; i++)
        {
          eval('document.getElementById("'+chkid+i+'").checked=false');
        }
      }
    }

    for (let i=0; i<props.modules.length; i++){
      if(eval("document.getElementById('view"+i+"').checked==true")){
        eval("document.getElementById('module"+i+"').checked=true");
      }else if(eval("document.getElementById('create"+i+"').checked==true")){
        eval("document.getElementById('module"+i+"').checked=true");
        eval("document.getElementById('view"+i+"').checked=true");
      }else if(eval("document.getElementById('update"+i+"').checked==true")){
        eval("document.getElementById('module"+i+"').checked=true");
        eval("document.getElementById('view"+i+"').checked=true");
      }else if(eval("document.getElementById('delete"+i+"').checked==true")){
        eval("document.getElementById('module"+i+"').checked=true");
        eval("document.getElementById('view"+i+"').checked=true");
      }else{
        eval("document.getElementById('module"+i+"').checked=false");
        eval("document.getElementById('view"+i+"').checked=false");
      }
    }

    selectedPrivilegesFun();

	}

  function userRole(){ 
		let totalRows = props.modules.length;
		if(document.getElementById("modules").checked==true){
			document.getElementById("viewall").checked=true;
			document.getElementById("createall").checked=true;
			document.getElementById("updateall").checked=true;
			document.getElementById("deleteall").checked=true;
			
			for(var i=0; i<totalRows; i++){
				eval("document.getElementById('module"+i+"').checked=true");
				eval("document.getElementById('view"+i+"').checked=true");
				eval("document.getElementById('create"+i+"').checked=true");
				eval("document.getElementById('update"+i+"').checked=true");
				eval("document.getElementById('delete"+i+"').checked=true");
			}
		}else if(document.getElementById("modules").checked==false){
			document.getElementById("viewall").checked=false;
			document.getElementById("createall").checked=false;
			document.getElementById("updateall").checked=false;
			document.getElementById("deleteall").checked=false;
			
			for(var i=0; i<totalRows; i++){
				eval("document.getElementById('module"+i+"').checked=false");
				eval("document.getElementById('view"+i+"').checked=false");
				eval("document.getElementById('create"+i+"').checked=false");
				eval("document.getElementById('update"+i+"').checked=false");
				eval("document.getElementById('delete"+i+"').checked=false");
			}
			
		}

    selectedPrivilegesFun();
		
	}

  function moduleUserRole(idNum){ 
		if(eval("document.getElementById('module"+idNum+"').checked==true")){
			eval("document.getElementById('view"+idNum+"').checked=true");
			eval("document.getElementById('create"+idNum+"').checked=true");
			eval("document.getElementById('update"+idNum+"').checked=true");
			eval("document.getElementById('delete"+idNum+"').checked=true");
		}else if(eval("document.getElementById('module"+idNum+"').checked==false")){
			eval("document.getElementById('view"+idNum+"').checked=false");
			eval("document.getElementById('create"+idNum+"').checked=false");
			eval("document.getElementById('update"+idNum+"').checked=false");
			eval("document.getElementById('delete"+idNum+"').checked=false");
		}
    selectedPrivilegesFun();
  }

  function privilegeOne(idNum){ 
		if(eval("document.getElementById('view"+idNum+"').checked==true")){
      eval("document.getElementById('module"+idNum+"').checked=true");
    }else if(eval("document.getElementById('create"+idNum+"').checked==true")){
      eval("document.getElementById('module"+idNum+"').checked=true");
      eval("document.getElementById('view"+idNum+"').checked=true");
    }else if(eval("document.getElementById('update"+idNum+"').checked==true")){
      eval("document.getElementById('module"+idNum+"').checked=true");
      eval("document.getElementById('view"+idNum+"').checked=true");
    }else if(eval("document.getElementById('delete"+idNum+"').checked==true")){
      eval("document.getElementById('module"+idNum+"').checked=true");
      eval("document.getElementById('view"+idNum+"').checked=true");
    }else{
      eval("document.getElementById('module"+idNum+"').checked=false");
      eval("document.getElementById('view"+idNum+"').checked=false");
    }
    selectedPrivilegesFun();
  }

  function selectedPrivilegesFun(){
    let selectedPrivileges = "";
    let totalRows = props.modules.length;
    for(let i=0; i<totalRows; i++){
      if(eval("document.getElementById('module"+i+"').checked==true")){
        selectedPrivileges+="#"+props.modules[i]+"@";
        if(eval("document.getElementById('view"+i+"').checked==true")){
          selectedPrivileges+="1";
        }
        if(eval("document.getElementById('create"+i+"').checked==true")){
          selectedPrivileges+="2";
        }
        if(eval("document.getElementById('update"+i+"').checked==true")){
          selectedPrivileges+="3";
        }
        if(eval("document.getElementById('delete"+i+"').checked==true")){
          selectedPrivileges+="4";
        }
  
      }

    }

    setPrivileges(selectedPrivileges);
  }


  return (
    <>
      <Dialog fullWidth maxWidth="md" onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle style={{marginBottom:'-30px'}} onClose={handleClose}></DialogTitle>
          <DialogContent style={{height:'80vh'}}>
            <Grid item   md={12} xs={12} className="test-instructions" >
                  <div className="btmbdrgry"><h3>{(props.dataObj && props.dataObj.autoId>0)?<>Edit</>:<>New</>} Role</h3></div>
                  <p>
                    {/* {privileges} */}
                      <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Role Name</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setRoleName(event.target.value)} value={roleName} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                            <td>Description</td>
                            <td style={{textAlign:'center'}} >
                            <TextField onChange={event => setDescription(event.target.value)} value={description} sx={{width:'99%',fontSize: 10}} variant="standard" />
                            </td>                            
                        </tr>
                        <tr style={{backgroundColor:'#FFFFFF'}} >
                          <td colSpan={2}>
                          <b>Privileges</b><br/> 

                            <table style={{backgroundColor:'#000000',width:'100%' }} cellSpacing="1" cellPadding="3" >
                            <tr style={{backgroundColor:'#FFFFFF'}} >
                                <td>
                                  <input id="modules" onClick={()=>{userRole()}} type="checkbox"  />
                                  Modules
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                {/* <i className="fa fa-check-square-o" style={{fontSize:15,color:'#0158dc'}} ></i>
                                <i className="fa fa-square-o" style={{fontSize:15}} ></i> */}
                                  <input id="viewall" onClick={()=>{checkAllList('viewall','view')}}  type="checkbox"  />
                                  View
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id="createall" onClick={()=>{checkAllList('createall','create')}}  type="checkbox"  />
                                  Create
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id="updateall" onClick={()=>{checkAllList('updateall','update')}}  type="checkbox"  />
                                  Update
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id="deleteall" onClick={()=>{checkAllList('deleteall','delete')}}  type="checkbox"  />
                                  Delete
                                </td>                            
                            </tr>
                            {props.modules?props.modules.map((myRow,mykey)=>(
                            <tr key={'k'+mykey} style={{backgroundColor:'#FFFFFF'}} >
                                <td>
                                  <input id={"module"+mykey} onClick={()=>{moduleUserRole(mykey)}} type="checkbox" />
                                  {myRow}
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id={"view"+mykey} onClick={()=>{privilegeOne(mykey)}} type="checkbox" />
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id={"create"+mykey} onClick={()=>{privilegeOne(mykey)}} type="checkbox" />
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id={"update"+mykey} onClick={()=>{privilegeOne(mykey)}} type="checkbox" />
                                </td>
                                <td style={{textAlign:'center',width:100}} >
                                  <input id={"delete"+mykey} onClick={()=>{privilegeOne(mykey)}} type="checkbox" />
                                </td>                            
                            </tr>
                            )):null}

                            </table>
                              
                          </td>
                        </tr>
                                              
                      </table>

                      <Box mt={2}>
                          <Button onClick={() => {handleClose()}} style={{marginRight:12}} size="small" variant="outlined" >Cancel</Button>
					    	          <Button onClick={() => {saveData()}} size="small" variant="contained" style={{backgroundColor:'#008000',color:'#FFF',marginRight:10}} >Save</Button>
								      </Box>

                  </p>
            </Grid>
          </DialogContent>
      </Dialog>
      
        <Stack spacing={2} sx={{ width: '100%' }}>
					<Snackbar open={showAlert} autoHideDuration={6000} onClose={hideAlert} anchorOrigin={{vertical,horizontal}}  >
						<Alert onClose={hideAlert} variant="filled" severity={severityAlert} sx={{ width: '100%' }}>
							{alertMessage}
						</Alert>
					</Snackbar>
				</Stack>

    </>
  );

});

export default CustomizedDialogs;